module.exports = __webpack_public_path__ + "assets/img/ferment_active.50de1098.png";